import { render } from "./UserEditResume.vue?vue&type=template&id=45169001&ts=true"
import script from "./UserEditResume.vue?vue&type=script&lang=ts"
export * from "./UserEditResume.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__